import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@chakra-ui/react';
import { ItemSuggestedListingsApiClient } from 'api/itemSuggestedListings';
import { PaginationModel, ItemSuggestedListingModel } from 'models';
import { JSONObject } from 'models/Api/types';

export function useItemSuggestedListings(itemId: string, params: JSONObject = {}, enabled: boolean = true) {
  return useQuery<PaginationModel<ItemSuggestedListingModel>>({
    queryKey: ['item-suggested-listings', itemId, params],
    queryFn: () => ItemSuggestedListingsApiClient.getSuggestedListings(itemId, params),
    enabled: enabled && !!itemId,
  });
}

export const useRecomputeItemSuggestions = () => {
  const queryClient = useQueryClient();
  const toast = useToast();

  return useMutation<void, Error, string>({
    mutationFn: (itemId: string) => ItemSuggestedListingsApiClient.recomputeItemSuggestions(itemId),
    onSuccess: async (_data, itemId) => {
      await queryClient.invalidateQueries({ queryKey: ['item-suggested-listings', itemId] });
      toast({
        title: 'Recompute requested',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
    },
    onError: (error: Error) => {
      toast({
        title: 'Failed to recompute suggestions',
        description: error.message,
        status: 'error',
        duration: 4000,
        isClosable: true,
      });
    }
  });
};
